import { globalLoggerToken, localizationInfoProviderToken } from "@/tokens";
import { CommonModule } from "@modules/common_module/CommonModule";
import { container, instanceCachingFactory, singleton } from "tsyringe";

import { ModuleInterface } from "@interfaces/ModuleInterface";

import { ProductApiServiceInterface } from "./api_services/ProductApiServiceInterface";
import { ShopifyGraphQLProductApiService } from "./api_services/ShopifyGraphQLProductApiService";
import { ProductQuery } from "./queries/ProductQuery";
import { ProductService } from "./services/ProductService";
import { ProductStore } from "./stores/ProductStore";
import {
    productQueryToken,
    productsApiServiceToken,
    productsServiceToken,
    productsStoreToken,
} from "./tokens";

@singleton()
export class ProductModule
    implements
        ModuleInterface<{
            productsApiService: ProductApiServiceInterface | null;
            productsStore: ProductStore;
            productQuery: ProductQuery;
            productsService: ProductService;
        }>
{
    exports: {
        productsApiService: ProductApiServiceInterface | null;
        productsStore: ProductStore;
        productQuery: ProductQuery;
        productsService: ProductService;
    };
    public constructor(private readonly commonModule: CommonModule) {
        container.register(productsApiServiceToken, {
            useFactory: instanceCachingFactory(() => {
                const localizationInfoProvider = container.resolve(
                    localizationInfoProviderToken
                );

                if (this.commonModule.exports.graphqlApiClient) {
                    return new ShopifyGraphQLProductApiService(
                        this.commonModule.exports.graphqlApiClient,
                        localizationInfoProvider.getCountryIsoCode(),
                        localizationInfoProvider.getLanguageIsoCode()
                    );
                }
                return null;
            }),
        });
        container.register(productsStoreToken, {
            useFactory: instanceCachingFactory(() => {
                return new ProductStore();
            }),
        });
        container.register(productQueryToken, {
            useFactory: instanceCachingFactory(() => {
                return new ProductQuery(container.resolve(productsStoreToken));
            }),
        });
        container.register(productsServiceToken, {
            useFactory: instanceCachingFactory(() => {
                return new ProductService(
                    container.resolve(productsApiServiceToken),
                    container.resolve(productsStoreToken),
                    container.resolve(globalLoggerToken)
                );
            }),
        });
        container.resolve(productsServiceToken).subscribe();
        this.exports = {
            productsApiService: container.resolve(productsApiServiceToken),
            productsStore: container.resolve(productsStoreToken),
            productQuery: container.resolve(productQueryToken),
            productsService: container.resolve(productsServiceToken),
        };
    }
    registerProviders() {
        return {};
    }
}
